const allowNativeContextMenuSelectors = 'input, textarea, [contenteditable="true"]';

const shouldAllowNativeContextMenu = (target: EventTarget | null): boolean => {
  const targetElement = target instanceof HTMLElement ? target : null;

  if (!targetElement) {
    return false;
  }

  return targetElement.matches(allowNativeContextMenuSelectors);
};

export function registerContextMenuListener() {
  const handleContextMenu = (event: MouseEvent) => {
    if (!shouldAllowNativeContextMenu(event.target)) {
      event.preventDefault();
    }
  };

  document.addEventListener('contextmenu', handleContextMenu);

  return () => {
    document.removeEventListener('contextmenu', handleContextMenu);
  };
}
